import React, { useState, useRef, useEffect, useContext } from "react";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { usePlacesWidget } from "react-google-autocomplete";
import { useHistory } from 'react-router-dom';
import { getFirstAutoCompletePlace, cacheLocationFromPlace } from "./utils.js";
import { translate } from "../../../utility/strings.js";
import GeoLocate from "@assets/GeoLocate.svg";
import Search from "@assets/Search.svg";

const SearchBox = () => {

  const history = useHistory();
  const submiting = useRef(false);
  const searchParams = new URLSearchParams(history.location.search);
  const [q, setQ] = useState(searchParams.get("q") || "");
  const [loading, setLoading] = useState(false);
  const autoLocate = useFeatureIsOn("dl-auto-locate");

  const { ref } = usePlacesWidget({
    // apiKey:apiKey,
    inputAutocompleteValue: "off",
    onPlaceSelected: (place) => {
      if(place.geometry){
        submiting.current = true
        setLoading(true);
        cacheLocationFromPlace(place);
        searchEvent("autocomplete", place.geometry.location.lat(), place.geometry.location.lng(), place.address_components);
        const countryComponent = place.address_components.filter( ( component ) => ( component.types.indexOf("country") > -1 ) )[0]
        redirectToResults(place.formatted_address, place.geometry.location.lat(), place.geometry.location.lng(), countryComponent && countryComponent.short_name);
      }else{
        submitSearch(place.name);
      }
    },
    options: {
      fields: ["address_components", "geometry.location", "formatted_address"],
      componentRestrictions: { country: ["us","ca"] }
    }
  });

  useEffect(() => {
    if(autoLocate){
      const searchParams = new URLSearchParams(location.search);
      history.push(`/search?${searchParams.toString()}`);
    }
  }, [autoLocate]);

  const handleSearchChange = (e) => {
    setQ(e.target.value);
  }

  const submitSearch = async (q) => {
    setLoading(true);
    const place = await getFirstAutoCompletePlace(q);
    cacheLocationFromPlace(place);
    searchEvent("search", place.geometry.location.lat(), place.geometry.location.lng(), place.address_components);
    const countryComponent = place.address_components.filter( ( component ) => ( component.types.indexOf("country") > -1 ) )[0]
    redirectToResults(place.formatted_address, place.geometry.location.lat(), place.geometry.location.lng(), countryComponent && countryComponent.short_name);
  }

  const handleSubmit = (e) => {
    //wait to see if autocomplete is handling the request
    setTimeout(()=>{
      if(!submiting.current){
        submitSearch(q);
      }
    }, 500)
  }

  const handleGeoLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      searchEvent("geolocation", position.coords.latitude, position.coords.longitude, [])
      redirectToResults( "Current Location", position.coords.latitude, position.coords.longitude);
    }, (error) => {
      console.warn(`ERROR(${error.code}): ${error.message}`);
      alert(`${error.message}`);
    });
  }

  const searchEvent = (type, lat, lng, components) => {
    const detail = {
      search_type: type,
      lat,
      lng,
      query: q
    }

    for(var i = 0; i < components.length; i++){
      const {types, short_name} = components[i];
      if(types.indexOf("postal_code") > -1){
        detail.postal_code = short_name;
      }
      if(types.indexOf("country") > -1){
        detail.country = short_name;
      }
      if(types.indexOf("administrative_area_level_1") > -1){
        detail.region = short_name;
      }
      if(types.indexOf("administrative_area_level_2") > -1){
        detail.county = short_name;
      }
      if(types.indexOf("locality") > -1){
        detail.city = short_name;
      }
    }
    const event = new CustomEvent('dealerLocator:search', { detail: detail });

    document.dispatchEvent(event);
  }

  const redirectToResults = (q, lat, lng, country) => {
    setQ(q);
    const searchParams = new URLSearchParams(history.location.search);

    searchParams.set("q", q);
    searchParams.set("lat", lat);
    searchParams.set("lng", lng);
    if(country){
      searchParams.set("country", country);
    }
    setLoading(false);
    history.push(`/search?${searchParams.toString()}`);
  }

  return (
    <form method="get" action="dealer-locator/search" onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
      <div className="ft_dealer-locator__search-box ft_dealer-locator__grouped-input">
        <div className="ft_dealer-locator__search-box__input ft_dealer-locator__input">
          {'geolocation' in navigator ?
            <div id="geoCodeDevice" onClick={handleGeoLocation} className="ft_dealer-locator__icon-btn absolute">
              <GeoLocate />
            </div>
          :null}
          <input className="input--underline shadow" ref={ref} name="q" type="search" placeholder={translate("dealer_locator.search_placeholder", "City, State")} onChange={handleSearchChange} value={q} autoFocus />
          <button type="submit" disabled={loading} className="ft_dealer-locator__button absolute" onClick={handleSubmit}>
            {/* {translate("dealer_locator.search", "Search")} */}
            <Search />
          </button>
        </div>
      </div>
    </form>
  );

}

export default SearchBox;
